import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { theme } from '_constants/theme';
import { selectError, selectLoading, selectPasswordSetStatus } from '_store/user/selector';
import { setPassword } from '_store/user/slice';

import { ReactComponent as LogoSvg } from 'assets/images/login-logo.svg';

import Card from 'components/atomic/layouts/Card';
import SetPasswordForm from 'components/composed/forms/SetPasswordForm';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: ${theme.spaces.regular}px;
  background-color: ${theme.colors.linkWater};
`;

const StyledInnerContainer = styled.div`
  max-width: 480px;
  width: 100%;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${theme.spaces.largeX}px;
`;

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const success = useSelector(selectPasswordSetStatus);
  const error = useSelector(selectError);

  const handleSubmit = (values) => {
    const token = searchParams.get('token');

    if (values && token) {
      const { newPassword } = values;
      dispatch(setPassword({ token, password: newPassword, category: CATEGORY_CODES.accounting }));
    }
  };

  useEffect(() => {
    if (success) {
      navigate('/login');
    }
  }, [success]);

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card>
          <StyledLogoContainer>
            <LogoSvg />
          </StyledLogoContainer>
          <SetPasswordForm loading={loading} error={error} onSubmit={handleSubmit} />
        </Card>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default ResetPasswordPage;
